import React from 'react';

// Compact KPI strip for shift summary in Calendar V3 header.
// `summary` (from /roster/board) wins when provided; otherwise computed from `shifts`.
export function CalendarSummaryCards({ shifts = [], summary = null }) {
  const total = summary ? summary.total : shifts.length;
  const open = summary ? summary.open : shifts.filter(s => s.status === 'OPEN').length;
  const assigned = summary ? summary.assigned : shifts.filter(s => ['ASSIGNED', 'CONFIRMED'].includes(s.status)).length;
  const inProgress = summary ? summary.active : shifts.filter(s => s.status === 'IN_PROGRESS').length;
  const completed = summary ? summary.done : shifts.filter(s => s.status === 'COMPLETED').length;
  const coverage = summary ? summary.coverage : (total > 0 ? Math.round(((assigned + inProgress + completed) / total) * 100) : 0);
  const items = [
    { label: 'Total', value: total, color: 'text-slate-900' },
    { label: 'Open', value: open, color: 'text-blue-600' },
    { label: 'Assigned', value: assigned, color: 'text-violet-600' },
    { label: 'Active', value: inProgress, color: 'text-sky-600' },
    { label: 'Done', value: completed, color: 'text-emerald-600' },
    { label: 'Coverage', value: `${coverage}%`, color: coverage >= 80 ? 'text-emerald-600' : coverage >= 50 ? 'text-amber-600' : 'text-red-600' },
  ];
  return (
    <div className="grid grid-cols-6 gap-2" data-testid="summary-bar">
      {items.map(i => (
        <div key={i.label} className="bg-white rounded-lg border px-3 py-1.5 text-center">
          <p className={`text-lg font-bold leading-tight ${i.color}`}>{i.value}</p>
          <p className="text-[10px] text-muted-foreground uppercase tracking-wide">{i.label}</p>
        </div>
      ))}
    </div>
  );
}
